<page-grid [gridConfig]="clientsGrid" (gridClickColumn)="openModal($event)" />